import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ComponentAbstract } from '@app/components/abstract/component.abstract';
import { BreadcrumbItem } from '@shared/interfaces/breadcrumb-item';
import { HelpRouterService } from '@shared/services/help-router.service';

@Component({
  selector: 'app-breadcrumb-item',
  templateUrl: './breadcrumb-item.component.html',
  styleUrls: ['./breadcrumb-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbItemComponent extends ComponentAbstract implements OnInit {
  constructor(protected cdr: ChangeDetectorRef, private router: Router, private helpRouterService: HelpRouterService) {
    super(cdr);
  }

  @Input() item: BreadcrumbItem;

  ngOnInit(): void {}

  open() {
    const queryParams = this.helpRouterService.getGlobalPreservedParams();
    if (this.item?.url) {
      this.reloadRoute().then(() => this.router.navigate([this.item.url], { queryParams }));
    }
  }

  private reloadRoute(): Promise<boolean> {
    return this.router.navigateByUrl('/', { skipLocationChange: true });
  }
}
